/**
 * Planned drilling map coordinates used by PlannedDrillingMap.
 * Rows in the drilling dashboard/API are filtered to those with finite `lat`/`lon` columns.
 * GeoJSON Point is a fallback renderer path if the API ever returns a point without columns.
 */

/** @param {Record<string, unknown>} row */
export function plannedHoleHasLatLon(row) {
  const la = Number(row.lat);
  const lo = Number(row.lon);
  return Number.isFinite(la) && Number.isFinite(lo);
}

/**
 * Lat/lng for Leaflet: lat/lon columns if valid, else GeoJSON point.
 * @param {Record<string, unknown>} row
 * @returns {[number, number]|null}
 */
export function plannedHoleLatLng(row) {
  const la = Number(row.lat);
  const lo = Number(row.lon);
  if (Number.isFinite(la) && Number.isFinite(lo)) return [la, lo];
  const g = row.geom_geojson;
  if (g && typeof g === 'object' && g.type === 'Point' && Array.isArray(g.coordinates)) {
    const [lng, lat] = g.coordinates;
    if (Number.isFinite(lat) && Number.isFinite(lng)) return [lat, lng];
  }
  return null;
}
